if (typeof SearchSidebar === 'undefined') {
  class SearchSidebar extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = {};
      //this.input = this.querySelector('.js-search-input');
      this.startSearch = this.querySelector('.js-start-search');

      this.group = {
      	links: this.querySelector('.js-search-links'),
      	suggests: this.querySelector('.js-search-suggests'),
      	results: this.querySelector('.js-search-results')
      }

      this.resultsContent = this.querySelector('.js-search-results-content');
      this.suggestItems = this.querySelectorAll('.js-search-suggest');
      this.resultBottom = this.querySelector('.js-search-results-bottom');

      this.searchClose = this.querySelectorAll('.js-search-close');

      this.setupEventListeners();
    }

    setupEventListeners () {
    	if (this.input) {
    		this.input.addEventListener('focus', this.onFocus.bind(this));
        this.input.addEventListener('keydown', this.onKeyUp.bind(this));
    	}

      if (this.startSearch) this.startSearch.addEventListener('click', this.onStartSearch.bind(this));

    	this.suggestItems.forEach(item => {
    		item.addEventListener('click', this.onSuggest.bind(this));
    	});

      this.searchClose.forEach(item => {
        item.addEventListener('click', this.closeSearch.bind(this));
      });

      this.addEventListener('click', (e) => {
        const target = e.target;

        if (target.classList.contains('js-cancel-search') || target.closest('.js-cancel-search')) {
          this.onCancelSearch()
        }
      });

      document.addEventListener('click', (e) => {
        const target = e.target;

        // Opens search sidebar from header simple search input
        const targets = ['search-icon']
        if (targets.includes(target.getAttribute('data-testid'))  ) {
          this.openSearch();
        }
      })

      // Fires the events for Searchsidebar using Header Simple input
      document.addEventListener('input', (e) => {
        const target = e.target;
        this.simpleInput = this.getSimpleInput()

        if ((target.getAttribute('data-testid') === 'search-input')) {
          this.simpleInput.addEventListener('focus', this.onFocus.bind(this));
          this.simpleInput.addEventListener('keydown', this.onKeyUp.bind(this));
        }
      })
    }

    // #region Header Simple Input
    getSimpleInput() {
      return document.getElementById('simple-search');
    }

    getSimpleQuery() {
      return this.simpleInput.value.trim();
    }
    // #endregion Header Simple Input

	  getQuery() {
	    return this.input.value.trim();
	  }

    onFocus() {
    	const searchTerm = this.getQuery();

    	if (!searchTerm) {
    		this.showGroup('suggests');
    	}
    }

    onKeyUp (event) {
      if (event.code == 'Enter') {
        this.redirectToSearch();
      } else {
        setTimeout(() => {
          if (this.getQuery()) {
            this.getSearchResults(this.getQuery());
          }
          if(this.getSimpleQuery()) {
            this.getSearchResults(this.getSimpleQuery());
          }
        }, 200);
      }
    }

    onStartSearch () {
      this.redirectToSearch();
    }

    onCancelSearch () {
    	this.input.value = '';
    	this.showGroup('links');
    }

    onSuggest(e) {
    	e.preventDefault();

    	const value = e.target.getAttribute('data-value');
    	if (value) {
    		this.input.value = value;
    		this.getSearchResults(value.trim());
    	}
    }

    redirectToSearch () {
      window.location.href = `${routes.search_url}?q=${this.input.value}`
    }

    openSearch () {
      this.classList.add('active')
    }

    closeSearch () {
      this.classList.remove('active')
      this.onCancelSearch()
      // Header Search Input Clear
      this.simpleInput = this.getSimpleInput()
      this.simpleInput.value = ""
    }

    showGroup (group) {
    	switch (group) {
    		case 'suggests':
    			if (this.group.links) this.group.links.classList.add('hidden');
    			if (this.group.suggests) this.group.suggests.classList.remove('hidden');
    			if (this.group.results) this.group.results.classList.add('hidden');
    		break;
    		case 'results':
    			if (this.group.links) this.group.links.classList.add('hidden');
    			if (this.group.suggests) this.group.suggests.classList.add('hidden');
    			if (this.group.results) this.group.results.classList.remove('hidden');
    		break;
    		default:
    			if (this.group.links) this.group.links.classList.remove('hidden');
    			if (this.group.suggests) this.group.suggests.classList.add('hidden');
    			if (this.group.results) this.group.results.classList.add('hidden');
    		break;
    	}
    }

    getSearchResults (searchTerm) {
      const queryKey = handleize(searchTerm);

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,page,article,collection&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults (resultsMarkup) {
      this.resultsContent.innerHTML = resultsMarkup;
      this.showGroup('results');

      if (this.resultBottom) {
        const resultsMarkupHTML = new DOMParser().parseFromString(resultsMarkup, 'text/html');
        if (resultsMarkupHTML.querySelector('[data-no-result]')) {
          this.resultBottom.classList.remove('hidden')
        } else {
          this.resultBottom.classList.add('hidden')
        }
      }
    }
  }

  if(customElements.get('search-sidebar') === undefined) {
    customElements.define('search-sidebar', SearchSidebar);
  }
}
